import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

function _window(): any {
  // return the native window obj
  return window;
}

function _document(): any {
  // return the native document obj
  return document;
}

// Tamanho em que ocorre a transformação para mobile até laptop
const tamanhoMobileExtra = 1040;

// Tamanho em que ocorre a transformação para mobile
const tamanhoMobile = 769;

// Tamanho em que ocorre a transformação para mobile dispositivos mini
const tamanhoMobileSmall = 400;

export enum AgendamentoTipoEnum {
  PI = "Piaui",
  GO = "Goias",
  MT = "Mato Grosso",
  ES = "Espirito Santo",
}

@Injectable()
export class GlobalService {
  resultadoLaudosGrid = [];
  resultadoLaudosRenavam = "";
  resultadoLaudosPlaca = "";
  temaSub = new Subject<boolean>();
  tema = false;
  urlImgSub = new Subject<string>();
  scrollChanged = new Subject<boolean>();
  public gridHeight: number;
  public overflowChanged: Subject<boolean> = new Subject<boolean>();
  pagamentoLoadingChanged = new Subject<any>();
  public historicoNavegacao = [];
  auxExibirFiltros = true;
  listaPermissoesSelectServicos = new Subject<any>();
  public emailValidatorRegex = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
  ufList = [
    { Key: "AC", Value: "AC" },
    { Key: "AL", Value: "AL" },
    { Key: "AM", Value: "AM" },
    { Key: "AP", Value: "AP" },
    { Key: "BA", Value: "BA" },
    { Key: "CE", Value: "CE" },
    { Key: "DF", Value: "DF" },
    { Key: "ES", Value: "ES" },
    { Key: "GO", Value: "GO" },
    { Key: "MA", Value: "MA" },
    { Key: "MG", Value: "MG" },
    { Key: "MS", Value: "MS" },
    { Key: "MT", Value: "MT" },
    { Key: "PA", Value: "PA" },
    { Key: "PB", Value: "PB" },
    { Key: "PE", Value: "PE" },
    { Key: "PI", Value: "PI" },
    { Key: "PR", Value: "PR" },
    { Key: "RJ", Value: "RJ" },
    { Key: "RN", Value: "RN" },
    { Key: "RO", Value: "RO" },
    { Key: "RR", Value: "RR" },
    { Key: "RS", Value: "RS" },
    { Key: "SC", Value: "SC" },
    { Key: "SE", Value: "SE" },
    { Key: "SP", Value: "SP" },
    { Key: "TO", Value: "TO" },
  ];

  /*  Constrói a tela, instaciando todos os serviços a serem utilizados pela mesma
 Se necessário, checa as permissoes de usuário para permitir quais operações de Crud poderão ser executadas */
  constructor() {}

  get nativeWindow(): any {
    return _window();
  }

  get nativeDocument(): any {
    return _document();
  }

  /* Verifica se está em modo mobile grande ou não */
  isMobileExtra() {
    return this.nativeWindow.innerWidth < tamanhoMobileExtra;
  }

  /* Verifica se está em modo mobile menor ou não */
  isMobile() {
    return this.nativeWindow.innerWidth < tamanhoMobile;
  }

  /* Verifica se está em modo mobile menor ou não */
  isMobileSmall() {
    return this.nativeWindow.innerWidth < tamanhoMobileSmall;
  }

  hideNavbar(hide: boolean) {
    this.scrollChanged.next(hide);
  }

  exibirLoadingPagamento(exibir) {
    this.pagamentoLoadingChanged.next(exibir);
  }

  validarCPF(cpf: string) {
    const cpfConvertido = cpf.replace(/[^\d]/g, "");

    let auxRepetidos = false;
    for (let i = 1; i < cpfConvertido.length; i++) {
      if (cpfConvertido[i] === cpfConvertido[0]) {
        auxRepetidos = true;
      } else {
        auxRepetidos = false;
        break;
      }
    }
    if (auxRepetidos) {
      return false;
    }

    let soma = 0;
    let mult = 10;
    for (let i = 0; i < 9; i++) {
      soma += parseInt(cpfConvertido.charAt(i), 10) * mult;
      mult--;
    }
    let subSoma = 0;
    let divSoma = soma % 11;
    if (divSoma > 1) {
      subSoma = 11 - divSoma;
    }
    if (subSoma === parseInt(cpfConvertido.charAt(9), 10)) {
      soma = 0;
      subSoma = 0;
      mult = 11;
      for (let i = 0; i < 10; i++) {
        soma += parseInt(cpfConvertido.charAt(i), 10) * mult;
        mult--;
      }
      divSoma = soma % 11;
      if (divSoma > 1) {
        subSoma = 11 - divSoma;
      }
      if (subSoma === parseInt(cpfConvertido.charAt(10), 10)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  validarCNPJ(cnpj: string) {
    if (cnpj.length > 18) return false;
    const digitsOnly = /^\d{14}$/.test(cnpj);
    const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(cnpj);

    if (digitsOnly || validFormat) true;
    else return false;

    const match = cnpj.toString().match(/\d/g);
    const numbers = Array.isArray(match) ? match.map(Number) : [];

    if (numbers.length !== 14) return false;

    const items = [...new Set(numbers)];
    if (items.length === 1) return false;

    const calc = (x) => {
      const slice = numbers.slice(0, x);
      let factor = x - 7;
      let sum = 0;

      for (let i = x; i >= 1; i--) {
        const n = slice[x - i];
        sum += n * factor--;
        if (factor < 2) factor = 9;
      }

      const result = 11 - (sum % 11);
      return result > 9 ? 0 : result;
    };

    const digits = numbers.slice(12);

    const digit0 = calc(12);
    if (digit0 !== digits[0]) return false;

    const digit1 = calc(13);
    return digit1 === digits[1];
  }

  obterDataString(data: Date) {
    const dia = data.getDate() < 10 ? "0" + data.getDate() : data.getDate();
    const mes =
      data.getMonth() + 1 < 10
        ? "0" + data.getMonth() + 1
        : data.getMonth() + 1;
    const ano = data.getFullYear();
    const hora = data.getHours() < 10 ? "0" + data.getHours() : data.getHours();
    const minutos =
      data.getMinutes() < 10 ? "0" + data.getMinutes() : data.getMinutes();

    return dia + "/" + mes + "/" + ano + " " + hora + ":" + minutos;
  }
}
